import ArticleLayout from "@/components/feature/ArticleLayout";
import { seoArticles } from "@/mocks/articles";

export default function ArticleJordan() {
  const article = seoArticles.find((a) => a.slug === "kakobuy-spreadsheet-jordan-ranking")!;
  return <ArticleLayout article={article} />;
}